export default {
  placeholder: 'Buscar marca...',
};
